'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.openMobileNavSearch = openMobileNavSearch;
exports.setDestination = setDestination;
exports.setDate = setDate;
exports.setFlexibleDate = setFlexibleDate;
exports.logSearch = logSearch;

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-frontend/home/LOAD';
var LOAD_SUCCESS = 'redux-frontend/home/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-frontend/home/LOAD_FAIL';

var OPEN_MOBILE_NAV_SEARCH = 'redux-frontend/home/OPEN_MOBILE_NAV_SEARCH';
var SET_DESTINATION = 'redux-frontend/home/SET_DESTINATION';
var SET_DATE = 'redux-frontend/home/SET_DATE';
var SET_FLEX_DATE = 'redux-frontend/home/SET_FLEX_DATE';

_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var initialState = function initialState() {
  return {
    loaded: false,
    isOpenMobileNavSearch: false,
    destination: '',
    date: (0, _momentTimezone2.default)().startOf('day').add(1, 'day').toISOString(),
    isFlexibleDate: false
  };
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case OPEN_MOBILE_NAV_SEARCH:
      return (0, _extends3.default)({}, state, {
        isOpenMobileNavSearch: action.open
      });
    case SET_DESTINATION:
      return (0, _extends3.default)({}, state, {
        destination: action.destination
      });
    case SET_DATE:
      return (0, _extends3.default)({}, state, {
        date: action.date,
        isFlexibleDate: action.date ? state.isFlexibleDate : false
      });
    case SET_FLEX_DATE:
      return (0, _extends3.default)({}, state, {
        isFlexibleDate: action.isFlexibleDate
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.home && globalState.home.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/info/home');
    }
  };
}

function openMobileNavSearch() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_MOBILE_NAV_SEARCH,
    open: open
  };
}

function setDestination(destination) {
  return {
    type: SET_DESTINATION,
    destination: destination
  };
}
function setDate(date) {
  return {
    type: SET_DATE,
    date: date ? date.toISOString() : null
  };
}
function setFlexibleDate(isFlexibleDate) {
  return {
    type: SET_FLEX_DATE,
    isFlexibleDate: isFlexibleDate
  };
}

var LOG_SEARCH = 'redux-frontend/home/LOG_SEARCH';

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, LOG_SEARCH, function (action, getState) {
  return { name: 'Search', category: 'Home', source: action.source, date: getState().home.date, destination: getState().home.destination, isFlexibleDate: getState().home.isFlexibleDate };
}), (0, _defineProperty3.default)(_analytics, SET_DATE, function (action) {
  return { name: 'Set Date', category: 'Home', date: action.date };
}), (0, _defineProperty3.default)(_analytics, SET_DESTINATION, function (action) {
  return { name: 'Set Destination', category: 'Home', destination: action.destination };
}), (0, _defineProperty3.default)(_analytics, SET_FLEX_DATE, function (action) {
  return { name: 'Set Flexible Date', category: 'Home', isFlexibleDate: action.isFlexibleDate };
}), (0, _defineProperty3.default)(_analytics, OPEN_MOBILE_NAV_SEARCH, function (action) {
  return { name: action.open ? 'Open Mobile Search' : 'Close Mobile Search', category: 'Home' };
}), _analytics);

function logSearch(source) {
  return {
    type: LOG_SEARCH,
    source: source
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/home.js
// module id = 196
// module chunks = 47